<template>

  <!---->
  <div>
    <ShortCut></ShortCut>
    <LogoHome></LogoHome>
    <Navigation></Navigation>
    <div class="summary-class">
      <div class="row-class">
        <div class="col-50-class">
          <div class="liable-class">
            <lable>
              客户名称：
            </lable>
          </div>
          <div class="input-50-class">
            <el-popover
              placement="bottom-start"
              width="80%"
              :ref="'business-1'"
              trigger="manual">
              <el-button @click="closeBusPopover()" class="table-button-class">关闭</el-button>

              <el-table :data="clientGripData" @row-dblclick="clientSelected" height="350px">
                <el-table-column width="100" property="BUSINESSID" label="客户ID" v-if="false"></el-table-column>
                <el-table-column width="100" property="BUSINESSCODE" label="客户编号"></el-table-column>
                <el-table-column width="200" property="BUSINESSNAME" label="客户名称"></el-table-column>
                <el-table-column width="300" property="ADDRESS" label="客户地址"></el-table-column>
                <el-table-column width="300" property="RECEMAN" label="收货人"></el-table-column>
              </el-table>
              <el-input clearable slot="reference" @click="getClient" v-model="form.businessName" @keyup.enter.native="getClient()" placeholder="请输入检索条件"></el-input>
            </el-popover>
          </div>
        </div>
        <div class="col-50-class">
          <div class="liable-class">
            <lable>
              客户地址：
            </lable>
          </div>
          <div class="input-50-class">
            <el-input v-model="form.address" disabled>
            </el-input>
          </div>
        </div>
      </div>

      <div class="row-class">
        <div class="col-25-class">
          <div class="liable-class">
            <lable>
              货主组织：
            </lable>
          </div>
          <div class="input-25-class">
            <el-input v-model="form.orgName" disabled>
            </el-input>
          </div>
        </div>
        <div class="col-25-class">
          <div class="liable-class">
            <lable>
              配送方式：
            </lable>
          </div>
          <div class="input-25-class">
<!--            <el-input v-model="form.ship">-->
<!--            </el-input>-->

<!--            <el-autocomplete-->
<!--              class="inline-input"-->
<!--              v-model="form.ship"-->
<!--              :fetch-suggestions="shipSearch"-->
<!--              placeholder="请选择配送方式"-->
<!--              @select="shipHandleSelect"-->
<!--            ></el-autocomplete>-->

            <el-select v-model="form.ship" clearable placeholder="请选择配送方式">
              <el-option
                v-for="item in shipList"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>

          </div>
        </div>
        <div class="col-50-class">
          <div class="liable-class">
            <lable>
              备注：
            </lable>
          </div>
          <div class="input-50-class">
            <el-input v-model="form.remark">
            </el-input>
          </div>
        </div>
      </div>
      <div class="row-class">
        <div class="col-20-class">
          <div class="liable-class">
            <lable>
              是否WMS
            </lable>
          </div>
          <div class="input-20-class">
            <el-switch
              v-model="form.IsWMS">
            </el-switch>
          </div>
        </div>
        <div class="col-20-class">
          <div class="liable-class">
            <lable>
              是否合单
            </lable>
          </div>
          <div class="input-20-class">
            <el-switch
              v-model="form.IsMerge">
            </el-switch>
          </div>
        </div>
        <div class="col-20-class">
          <div class="liable-class">
            <lable>
              是否平台
            </lable>
          </div>
          <div class="input-20-class">
            <el-switch
              v-model="form.IsPlatform">
            </el-switch>
          </div>
        </div>
        <div class="col-20-class">
          <div class="liable-class">
<!--            <el-button type="primary">单据调整</el-button>-->

            <el-popover
              placement="left"
              width="800"
              :ref="'bill-1'"
              trigger="click">
              <el-table :data="billHead" height="380px" @row-dblclick="getBill">
                <el-table-column width="130" property="BILLNO" label="单据NO" v-if="false"></el-table-column>
                <el-table-column width="130" property="BILLCODE" label="单号编号"></el-table-column>
                <el-table-column width="105" property="DATES" label="日期"></el-table-column>
                <el-table-column width="100" property="ONTIME" label="时间"></el-table-column>
                <el-table-column width="80" property="CLIENTCODE" label="客户编号"></el-table-column>
                <el-table-column width="200" property="BUSINESSNAME" label="单位名称"></el-table-column>
                <el-table-column width="80" property="SELLER" label="销售员"></el-table-column>
                <el-table-column width="80" property="CAOZYNAME" label="操作员"></el-table-column>
              </el-table>
              <el-button slot="reference" type="primary" @click="getBillAdj()">单据调整</el-button>
            </el-popover>

          </div>
        </div>
        <div class="col-20-class">
          <div class="liable-class">
            <el-button type="danger" @click="getBillDel()">单据删除</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="cont_title">
      <span>选择商品</span>
    </div>

    <div class="tableClass">
      <el-table ref="multipleTable" :data="formData.tableData" tooltip-effect="dark" style="width: 100%" border
      >
        <el-table-column  label="序号" show-overflow-tooltip width="50px">
          <template slot-scope="scopeSn" >
            <p v-text="scopeSn.$index+1"></p>
          </template>
        </el-table-column>
        <el-table-column  label="商品编号" width="150px" :show-overflow-tooltip="false">
          <template slot-scope="scope" >
            <el-popover
              placement="bottom-start"
              width="80%"
              trigger="manual"
              :ref="'popover-' + scope.row.id"
              popper-class="tooltip-wrap"
            >
              <el-button @click="closePopover(scope.row)" class="table-button-class">关闭</el-button>
              <el-table :data="gridData" :cell-style="changeCellStyle" height="350px">
                <el-table-column width="50" label="选择">
                  <template slot-scope="scopeSel">
                    <el-button type="text" size="small" @click.native.prevent="getDate (scope.$index,scopeSel.row)">
                      选择
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column width="100" property="GOODSCODE" label="商品编号">
                </el-table-column>
                <el-table-column width="150" property="GOODSNAME" label="商品名称"></el-table-column>
                <el-table-column width="150" property="GOODSSPEC" label="商品规格"></el-table-column>
                <el-table-column width="150" property="MANUFACTURER" label="生产厂家"></el-table-column>
                <el-table-column width="80" property="SALETAXP" label="最后售价"></el-table-column>
                <el-table-column width="100" property="BATCHCODE" label="批号"></el-table-column>
                <el-table-column width="110" property="PRODUCEDATE" label="生产日期"></el-table-column>
                <el-table-column width="110" property="VALDATE" label="有效期"></el-table-column>
                <el-table-column width="80" property="PLACENUM" label="可销数量" ></el-table-column>
              </el-table>
              <el-input slot="reference" @click="buttonClick" v-model="scope.row.GoodsCode" @keyup.enter.native="getDateSet(scope.row)" placeholder="请输入检索条件" ></el-input>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column  label="商品名称" show-overflow-tooltip width="150px">
          <template slot-scope="scope" >
            <p v-text="scope.row.GoodsName"></p>
          </template>
        </el-table-column>
        <el-table-column  label="商品规格" show-overflow-tooltip width="100px">
          <template slot-scope="scope" >
            <p v-text="scope.row.GoodsSpec"></p>
          </template>
        </el-table-column>
        <el-table-column  label="生产厂家" show-overflow-tooltip >
          <template slot-scope="scope" >
            <p v-text="scope.row.GoodsMan"></p>
          </template>
        </el-table-column>
        <el-table-column  label="批号" show-overflow-tooltip >
          <template slot-scope="scope" >
            <p v-text="scope.row.BatchCode"></p>
          </template>
        </el-table-column>
        <el-table-column  label="生产日期" show-overflow-tooltip >
          <template slot-scope="scope" >
            <p v-text="scope.row.ProduceDate"></p>
          </template>
        </el-table-column>
        <el-table-column  label="有效期" show-overflow-tooltip >
          <template slot-scope="scope" >
            <p v-text="scope.row.ValDate"></p>
          </template>
        </el-table-column>
        <el-table-column  label="数量" show-overflow-tooltip width="140px">
          <template slot-scope="scopeNum" >
            <el-input-number v-model="scopeNum.row.GoodsNum" @change="handleChange(scopeNum.row)" :min="1" :max="999999" label="请输入数量" size="small"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column  label="含税价" show-overflow-tooltip >
          <template slot-scope="scope" >
            <el-input slot="reference" @change="changeTaxPrice(scope.row,scope.$index)" @click="buttonClick" v-model="scope.row.GoodsTaxPrice" @keyup.enter.native="columnAmount(scope.row,scope.$index)" placeholder="请输入价格"></el-input>
          </template>
        </el-table-column>
        <el-table-column  label="含税金额" show-overflow-tooltip >
          <template slot-scope="scope" >
            <p v-text="scope.row.GoodsTaxAmount"></p>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-button type="text" @click="addData">添加数据</el-button>
      <el-divider></el-divider>
    </div>

    <div id="footer">
      <div class="foot_op">
        <div class="btn-area">
          <a class="left-btn" @click.prevent="emptyCart">清空</a>
        </div>
      </div>
      <div class="foot_total">
        <div class="amout-sum">
          <span class="txt">已选商品</span>
          <strong id="selected_amout">{{totalNum}}</strong>
          <span class="txt">件</span>
        </div>
        <div class="price-sum">
          <span class="txt">合计（不含运费）：{{totalAmount}}</span>
        </div>
        <div class="btn-area">
          <a class="btn-sumbit" :class="{'btn-allow': totalAmount} " @click.prevent="submitData()" >确定</a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ShortCut from '../component/ShortCut'
import Navigation from "../component/Navigation";
import LogoHome from "../component/LogoHome";
import {billOrders, getBillNo,saveBill,saveTable,billCheckOrders} from '../../api';
export default {
  components:{
    ShortCut,
    Navigation,
    LogoHome
  },
  data() {
    return {
      form:{
        businessName: "",
        address:"",
        orgName:"",
        ship:"",
        remark: "",
        IsWMS:true,
        IsMerge:false,
        IsPlatform:false,
        businessId:""
      },
      userInfo:{},
      clientGripData:[],
      shipList:[
        {"value": "配送", "name": "配送"},
        {"value": "自提", "name": "自提"},
      ],
      BillNo:0,
      BILLCODE:"",
      shopsNum: [],
      isSelectedAll: false,
      totalPrice: 0,  // 商品总价
      currentDelGoods: {}, // 当前删除的商品
      totalAmount: 0,
      totalNum: 0,
      referenceVal : "",
      formData: {
        tableData: [],
      },
      gridData:[],
      billHead:[],
      saveChk:false,
    }
  },
  methods: {
    getClient(){
      this.clientGripData=[];
      billOrders({
        M_STAFFID:this.userInfo.STAFFID,
        M_ORGID:this.userInfo.OWNERID,
        M_ENTID:this.userInfo.ENTID,
        M_CON:"%"+this.form.businessName ,
        M_COALL:"%"+this.form.businessName+"%",
        M_ACTION:0,
        M_PAGECOUNT:2000,
        M_PAGE:1
      }).then(res=>{
        // console.log(res);
        //这个接口数据是application/x-www-form-urlencoded，所以参数要进行qs转化
        // 请求返回数据
        let dataset = res.data.data.DATASET;
        if(dataset.length==0){
          this.$message.error('获取客户失败，请联系管理员！');
          return false;
        }else{
          this.clientGripData=dataset;
          // console.log(dataset[0]);
          // sessionStorage.setItem("USERINFO",dataset[0]);
          // this.$router.push('/home');
        }
      }).catch(err=>{
        // 请求失败执行
        // console.log(err)
      });
      this.$refs[`business-1`].doShow();
    },
    closeBusPopover(){
      this.$refs[`business-1`].doClose();
    },
    clientSelected(row){
      this.form.businessName = row.BUSINESSNAME;
      this.form.address = row.ADDRESS;
      this.form.businessId=row.BUSINESSID;
      this.$refs[`business-1`].doClose();
    },
    shipSearch(queryString, cb){
      var ship = this.shipList;
      var results = queryString ? ship.filter(this.shipFilter(queryString)) : ship;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    shipFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    shipHandleSelect(item){
      this.form.ship=item.name;
    },
    getDate(index,row){
      const that = this;
      billOrders({
        M_BUSINESSID:this.form.businessId,
        M_GOODSID:row.GOODSID,
        M_ORGID:row.OWNERID,
        M_ACTION:101,
      }).then(res=>{
        console.log(res);
        if(res.data.code==200){
          let dataset = res.data.data.DATASET;
          console.log(dataset);
          if(dataset.length!=0){
            let retJSON = dataset[0];
            if(retJSON.ISHOLD=='true'){
              that.$message.error(retJSON.CHKINFO);
              return false;
            }else{
              let goods = {};
              goods.GoodsCode = row.GOODSCODE;
              goods.GoodsName = row.GOODSNAME;
              goods.GoodsSpec = row.GOODSSPEC;
              goods.GoodsMan = row.MANUFACTURER;
              goods.GoodsTaxPrice = row.SALETAXP;
              goods.GoodsNum = 1;
              goods.GoodsTaxAmount = row.SALETAXP;
              goods.BatchCode = row.BATCHCODE;
              goods.ProduceDate = row.PRODUCEDATE;
              goods.ValDate = row.VALDATE;
              goods.BillNo = that.BillNo;
              goods.EntId = that.userInfo.ENTID;
              goods.GoodsId = row.GOODSID;
              goods.OwnerId = row.OWNERID;
              goods.PackId = row.PACKID;
              goods.Meas = row.MEAS;
              goods.AngleId = row.ANGLEID;
              goods.Rate = row.RATE;
              goods.WhOrgId = row.WHORGID;
              goods.IsDone = "N";
              goods.Unit = row.UNIT;
              goods.LocatId = row.LOCATID;
              goods.BillSN = index+1;
              goods.BillSort = index+1;
              goods.DedRate = 100;
              goods.Profit = 0;
              goods.Retailp = 0;
              goods.IsFree = "N";
              goods.OldPrice = 0;
              goods.NewPrice = 0;
              goods.OldTaxPrice = 0;
              goods.NewTaxPrice =0;
              goods.SoldNum=0;
              goods.NotSoldNum = 0;
              goods.OutCost = 0;
              goods.RfBillNo = 0;
              goods.RfBillSn = 0;
              goods.ReBillNo=0;
              goods.ReBillSn=0;
              goods.RfBillCode = "";
              goods.ReBillCode = "";
              goods.RfRuleId = "";
              goods.ReRuleId = "";
              goods.GRpNo=0;
              goods.CheckCost=0;
              goods.ActProfit = 0;
              goods.ActPrice = 0;
              goods.ActTaxPrice=0;
              goods.ActAmount = 0;
              goods.OldActPrice = 0;
              goods.NewActPrice = 0 ;
              goods.OldActTaxPrice = 0;
              goods.NewActTaxPrice = 0;
              goods.OutActCost = 0;
              goods.SaleTaxP = 0;
              goods.IS_HD = "N";
              goods.HDBILLNO=0;
              goods.HDBillSn=0;
              goods.PTTaxPrice = row.TAXPRICE;
              goods.YSBBillNo=0;
              goods.YSBBillSn=0;
              goods.BaseTaxPrice = row.GoodsTaxPrice;
              goods.TaxPrice = row.GoodsTaxPrice;
              goods.Price = row.GoodsTaxPrice;
              goods.BasePrice = row.GoodsTaxPrice;
              goods.isfree="N";
              goods.is_wlqr="N";
              goods.is_hwqr="N";
              goods.is_kfqr="N";
              goods.ischeck="N";
              goods.WhId = row.WHID;
              goods.WhOrgId = row.WHORGID;
              goods.kfqrshl=0;
              goods.kfqxshl=0;
              goods.WLQRSHL = 0;
              goods.WLQXSHL = 0;
              goods.WLQRJE = 0;
              goods.WLQRSHE = 0;
              goods.WLQRHSJE= 0;
              goods.KFQRJE= 0;
              goods.KFQRSHE=0;
              goods.KFQRHSJE = 0;
              goods.HWQRSHL=0;
              goods.HWQXSHL=0;
              goods.YHSSHL= 0;
              goods.YHESJE=0;
              goods.SOUBILLNO=0;
              goods.SOUBILLSN=0;
              goods.WLQRJG=0;
              goods.WLQRHSJ=0;
              goods.COST=0;
              goods.ISRETDONE='N';
              goods.REFUSEDNUM=0;
              goods.ISREFUSED="N";
              goods.GoodsGroup = row.GOODSGROUP;
              if(that.formData.tableData.length>0){
                let goodsGroup = that.formData.tableData[0].GoodsGroup;
                let goodsId = that.formData.tableData[0].GoodsId;
                if(goods.GoodsGroup != goodsGroup && goodsId !="" && goodsId != null){
                  that.$message.error("当前商品与已存在商品分组互斥，请检查！");
                  return false;
                }
              }
              that.formData.tableData.splice(index,1);
              that.formData.tableData.push(goods);
              that.$refs[`popover-` + row.id].doClose();
              that.lineCalculation();
            }
          }
        }else{
          that.$message.error(res.msg);
          return false;
        }
      }).catch(err=>{
        // 请求失败执行
        console.log(err)
      });

      // this.afterSelGoods(row).then(res=>{
      //   console.log(res);
      //   if(res){
      //     let goods = {};
      //     goods.GoodsCode = row.GOODSCODE;
      //     goods.GoodsName = row.GOODSNAME;
      //     goods.GoodsSpec = row.GOODSSPEC;
      //     goods.GoodsMan = row.MANUFACTURER;
      //     goods.GoodsTaxPrice = row.SALETAXP;
      //     goods.GoodsNum = 1;
      //     goods.GoodsTaxAmount = row.SALETAXP;
      //     goods.BatchCode = row.BATCHCODE;
      //     goods.ProduceDate = row.PRODUCEDATE;
      //     goods.ValDate = row.VALDATE;
      //     goods.BillNo = this.BillNo;
      //     goods.EntId = this.userInfo.ENTID;
      //     goods.GoodsId = row.GOODSID;
      //     goods.OwnerId = row.OWNERID;
      //     goods.PackId = row.PACKID;
      //     goods.Meas = row.MEAS;
      //     goods.AngleId = row.ANGLEID;
      //     goods.Rate = row.RATE;
      //     goods.WhOrgId = row.WHORGID;
      //     goods.IsDone = "N";
      //     goods.Unit = row.UNIT;
      //     goods.LocatId = row.LOCATID;
      //     goods.BillSN = index+1;
      //     goods.BillSort = index+1;
      //     goods.DedRate = 100;
      //     goods.Profit = 0;
      //     goods.Retailp = 0;
      //     goods.IsFree = "N";
      //     goods.OldPrice = 0;
      //     goods.NewPrice = 0;
      //     goods.OldTaxPrice = 0;
      //     goods.NewTaxPrice =0;
      //     goods.SoldNum=0;
      //     goods.NotSoldNum = 0;
      //     goods.OutCost = 0;
      //     goods.RfBillNo = 0;
      //     goods.RfBillSn = 0;
      //     goods.ReBillNo=0;
      //     goods.ReBillSn=0;
      //     goods.RfBillCode = "";
      //     goods.ReBillCode = "";
      //     goods.RfRuleId = "";
      //     goods.ReRuleId = "";
      //     goods.GRpNo=0;
      //     goods.CheckCost=0;
      //     goods.ActProfit = 0;
      //     goods.ActPrice = 0;
      //     goods.ActTaxPrice=0;
      //     goods.ActAmount = 0;
      //     goods.OldActPrice = 0;
      //     goods.NewActPrice = 0 ;
      //     goods.OldActTaxPrice = 0;
      //     goods.NewActTaxPrice = 0;
      //     goods.OutActCost = 0;
      //     goods.SaleTaxP = 0;
      //     goods.IS_HD = "N";
      //     goods.HDBILLNO=0;
      //     goods.HDBillSn=0;
      //     goods.PTTaxPrice = row.TAXPRICE;
      //     goods.YSBBillNo=0;
      //     goods.YSBBillSn=0;
      //     goods.BaseTaxPrice = row.GoodsTaxPrice;
      //     goods.TaxPrice = row.GoodsTaxPrice;
      //     goods.Price = row.GoodsTaxPrice;
      //     goods.BasePrice = row.GoodsTaxPrice;
      //     goods.isfree="N";
      //     goods.is_wlqr="N";
      //     goods.is_hwqr="N";
      //     goods.is_kfqr="N";
      //     goods.ischeck="N";
      //     goods.WhId = row.WHID;
      //     goods.WhOrgId = row.WHORGID;
      //     goods.kfqrshl=0;
      //     goods.kfqxshl=0;
      //     goods.WLQRSHL = 0;
      //     goods.WLQXSHL = 0;
      //     goods.WLQRJE = 0;
      //     goods.WLQRSHE = 0;
      //     goods.WLQRHSJE= 0;
      //     goods.KFQRJE= 0;
      //     goods.KFQRSHE=0;
      //     goods.KFQRHSJE = 0;
      //     goods.HWQRSHL=0;
      //     goods.HWQXSHL=0;
      //     goods.YHSSHL= 0;
      //     goods.YHESJE=0;
      //     goods.SOUBILLNO=0;
      //     goods.SOUBILLSN=0;
      //     goods.WLQRJG=0;
      //     goods.WLQRHSJ=0;
      //     goods.COST=0;
      //     goods.ISRETDONE='N';
      //     goods.REFUSEDNUM=0;
      //     goods.ISREFUSED="N";
      //     this.formData.tableData.splice(index,1);
      //     this.formData.tableData.push(goods);
      //     this.$refs[`popover-` + row.id].doClose();
      //     this.lineCalculation();
      //   }
      // })

    },

    async afterSelGoods(row){
      console.log(row);
      billOrders({
        M_BUSINESSID:this.form.businessId,
        M_GOODSID:row.GOODSID,
        M_ORGID:row.OWNERID,
        M_ACTION:101,
      }).then(res=>{
        console.log(res);
        if(res.data.code==200){
          let dataset = res.data.data.DATASET;
          console.log(dataset);
          if(dataset.length!=0){
            let retJSON = dataset[0];
            if(retJSON.ISHOLD=='true'){
              this.$message.error(retJSON.CHKINFO);
              return false;
            }else{
              return true;
            }
          }
        }else{
          this.$message.error(res.msg);
          return false;
        }
      }).catch(err=>{
        // 请求失败执行
        console.log(err)
      });
    },


    buttonClick(){
    },
    getDateSet(row){
      this.gridData = [];
      let valInfo = row.GoodsCode;
      const that = this;
      if(valInfo.length>0) {
        billOrders({
          M_STAFFID: this.userInfo.STAFFID,
          M_ORGID: this.userInfo.OWNERID,
          M_ENTID: this.userInfo.ENTID,
          M_CON: "%" + valInfo,
          M_COALL: "%" + valInfo + "%",
          M_ACTION: 1,
          M_PAGECOUNT: 1000,
          M_PAGE: 1,
          M_BUSINESSID:this.form.IsWMS==true ? 'Y' : 'N',
          M_GOODSID:this.form.IsPlatform ==true ? 'Y' : 'N',

        }).then(res => {
          // console.log(res);
          //这个接口数据是application/x-www-form-urlencoded，所以参数要进行qs转化
          // 请求返回数据
          let dataset = res.data.data.DATASET;
          // console.log("dataset" + dataset);
          if (dataset.length == 0) {
            that.$message.error('获取商品失败，请联系管理员！');
            return false;
          } else {
            //this.options=dataset;
            that.gridData = dataset;
            // console.log(dataset[0]);
            // sessionStorage.setItem("USERINFO",dataset[0]);
            // this.$router.push('/home');
          }
        }).catch(err => {
          // 请求失败执行
          // console.log(err)
        })

        that.$refs[`popover-` + row.id].doShow();
      }
      // console.log(this.referenceVal);
    },
    //添加
    addData() {

      if(this.formData.tableData.length!=0){
        if(this.formData.tableData[this.formData.tableData.length-1].GoodsId!=undefined){
          this.formData.tableData.push({});
        }
      }else{
        this.formData.tableData.push({});
      }

    },
    handleDelete(index, row){
      this.formData.tableData.splice(index,1);
      this.lineCalculation();
    },
    //确认添加
    confirmAdd(row, formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          row.edit = false;
        }
      })
    },
    changeCellStyle (row, column, rowIndex, columnIndex) {
      //列的label的名称
      if (row.column.label === "库存数量") {
        return 'color:red' //修改的样式
      } else {
        return ''
      }
    },
    //修改
    editData(row) {
      row.edit = true;
    },
    //删除
    deleteData(row, index) {
      this.formData.tableData.splice(index, 1);

    },
    emptyCart(){
      this.formData.tableData=[];
      this.lineCalculation();
    },
    async saveCheck(){
      await saveTable({
          "tablename": "GoodsOccu",
          "data": this.formData.tableData,
        }).then(async res => {
        let data = this.formData.tableData;
        // console.log(res);
        if (res.data.code == 200) {
          for (let j = 0; j < data.length; j++) {
            await billCheckOrders({
              M_STAFFID: this.userInfo.STAFFID,
              M_ORGID: this.userInfo.OWNERID,
              M_ENTID: this.userInfo.ENTID,
              M_CON: "%" + this.form.businessName,
              M_COALL: "%" + this.form.businessName + "%",
              M_ACTION: 1,
              M_PAGECOUNT: 2000,
              M_PAGE: 1,
              M_GOODSID: data[j].GoodsId,
              M_GOODSNAME: data[j].GoodsName,
              M_ANGLEID: data[j].AngleId,
              M_OWNERID: data[j].OwnerId,
              M_WHID: data[j].WhId,
              M_LOCATID: data[j].LocatId,
              M_BASENUM: data[j].BaseNum
            }).then(async res => {
              //这个接口数据是application/x-www-form-urlencoded，所以参数要进行qs转化
              // 请求返回数据
              let dataset = res.data.data.DATASET;
              if (dataset.length > 0 && dataset[0].CHKINFO != "") {
                this.$message.error(dataset[0].CHKINFO);
                await billCheckOrders({
                  M_STAFFID: this.userInfo.STAFFID,
                  M_ORGID: this.userInfo.OWNERID,
                  M_ENTID: this.userInfo.ENTID,
                  M_CON: "%" + this.form.businessName,
                  M_COALL: "%" + this.form.businessName + "%",
                  M_ACTION: 2,
                  M_PAGECOUNT: 2000,
                  M_PAGE: 1,
                  M_GOODSID: data[j].GoodsId,
                  M_GOODSNAME: data[j].GoodsName,
                  M_ANGLEID: data[j].AngleId,
                  M_OWNERID: data[j].OwnerId,
                  M_WHID: data[j].WhId,
                  M_LOCATID: data[j].LocatId,
                  M_BASENUM: data[j].BaseNum,
                  M_BILLNO: this.BillNo,
                  M_CLIENTID:this.form.businessId
                }).then(res => {
                }).catch(err => {
                });
                this.saveChk = false;
                return false;
              }else if(dataset.length > 0 && dataset[0].CHKINFO == ""){
                console.log("-----------------");
                this.saveChk = true;
                return true;
              }
              this.saveChk = false;
              return false;
              // if(dataset.length==0){
              //   this.$message.error('获取配送方式失败，请联系管理员！');
              //   return false;
              // }else{
              //
              // }
            }).catch(err => {
              // 请求失败执行
              this.$message.error('执行失败：' + err);
              this.saveChk = false;
              return false;
            });
          }

        } else {
          this.$message.error(res.data.msg);
          this.saveChk = false;
        }
      }).catch(err => {
          this.$message.error('提交订单失败，请联系管理员！');
          this.saveChk = false;
        })

    },
    async submitData() {
      // if(!this.saveCheck()){
      //   return false;
      // }
      // console.log(this.saveChk);
      // new Promise(res=>{
      //   this.saveCheck();
      // }).then(res=>{
      //   console.log("----"+this.saveChk);
      // })
      // console.log("====="+this.saveChk);
      this.saveChk = true;
      if(this.form.ship==null || this.form.ship==''){
        this.$message.error('配送方式不允许为空，请检查！');
        this.saveChk = false;
      }
      if(!this.saveChk){
        return false;
      }
      await this.saveCheck();
      if(!this.saveChk){
        return false;
      }

      let dates = new Date();
      let year = dates.getFullYear();
      let month = dates.getMonth()+1<10 ? "0"+ Math.round(dates.getMonth()+1) : dates.getMonth()+1;
      let date = dates.getDate()<10 ? "0"+ Math.round(dates.getDate()) : dates.getDate();
      let hours = dates.getHours()<10 ? "0"+ dates.getHours() : dates.getHours();
      let minutes = dates.getMinutes()<10 ? "0"+ dates.getMinutes() : dates.getMinutes();
      let seconds = dates.getSeconds()<10 ? "0"+ dates.getSeconds() : dates.getSeconds();
      let onDates = year + "-" + month + "-" +date;
      let onTimes = hours+":"+minutes+":"+seconds;
      year = year.toString().substring(2,2);
      this.BILLCODE = "SKPN"+year+""+month+""+date+""+hours+""+minutes+""+seconds;
      saveBill({
        "mttablename":"SaleNotesMt",
        "dttablename":"SaleNotesDt",
        "billno":this.BillNo,
        "billcode":this.BILLCODE,
        "entid":this.userInfo.ENTID,
        "ruleid":"67b55qi64q7dzsq2",
        "dates":onDates,
        "ontime":onTimes,
        "sysdates":onDates,
        "clientid":this.form.businessId,
        "accptid":this.form.businessId,
        "address":this.form.address,
        "payorgid":this.userInfo.OWNERID,
        "salemanid":this.userInfo.STAFFID,
        "caozy":this.userInfo.STAFFID,
        "orgid":this.userInfo.OWNERID,
        "deptid":"",
        "delivery":this.form.ship,
        "paytype":"挂帐",
        "isend":"Y",
        "kk_qyfzrid":this.userInfo.STAFFID,
        "goodsglist":1,
        "summaries":"协同订单",
        "remark":this.form.remark,
        "saleclientid":this.form.businessId,
        "dedrate":100,
        "hzid":this.userInfo.OWNERID,
        "currencyid":"CNY",
        "isdone":"N",
        "billstate":0,
        "data":this.formData.tableData,
        "is_wms":this.form.IsWMS == true ? 'Y' : 'N',
        "is_pt":this.form.IsPlatform == true ? 'Y' : 'N',
        "kk_ptqyfzrid":"",
        "is_hd":this.form.IsMerge == true ? 'Y' : 'N',
        "is_xf":"N",
        "ISWMSCR":"N",
        "isch":"N",
        "is_ysb":"N",
        "is_sp":"N",
        "ISVAT":"N",
        "PAIJIA":0,
        "ISSETTLE":"N",
        "ISAD":"N",
        "ADVAMT":0,
        "OLDBIllNo":0,
        "IS_DYZJBG":"N",
        "ISXYDJ":"N",
        "IS_JC":"N",
        "DIANS":0,
        "HDBillNo":0
      }).then(res => {
        // console.log(res);
        if(res.data.code==200){
          // this.$message({
          //   message: '提交成功！',
          //   type: 'success'
          // });
          saveBill({
            "mttablename":"SalesTwoMt",
            "dttablename":"SalesTwoDt",
            "billno":this.BillNo,
            "billcode":this.BILLCODE,
            "entid":this.userInfo.ENTID,
            "ruleid":"67b55qi64q7dzsq2",
            "is_wlqr":"N",
            "is_kfqr":"N",
            "is_hwqr":"N",
            "isend":"N",
            "issettle":"N",
            "isdone":"N",
            "data":this.formData.tableData,
          }).then(res => {
            // console.log(res);
            if(res.data.code==200){
              this.$message({
                message: '提交成功！',
                type: 'success'
              });
              this.formData.tableData=[];
              this.getBillNo();
            }else{
              this.$message.error(res.data.msg);
              return false;
            }
          }).catch(err => {
            this.$message.error('提交订单失败，请联系管理员！');
            return false;
          })

          this.formData.tableData=[];
        }else{
          this.$message.error(res.data.msg);
          return false;
        }
      }).catch(err => {
        this.$message.error('提交订单失败，请联系管理员！');
        return false;
      })
      // }
      // })
    },
    getShip(){
      billOrders({
        M_STAFFID:this.userInfo.STAFFID,
        M_ORGID:this.userInfo.OWNERID,
        M_ENTID:this.userInfo.ENTID,
        M_CON:"%"+this.form.businessName ,
        M_COALL:"%"+this.form.businessName+"%",
        M_ACTION:99,
        M_PAGECOUNT:2000,
        M_PAGE:1
      }).then(res=>{
        // console.log(res);
        //这个接口数据是application/x-www-form-urlencoded，所以参数要进行qs转化
        // 请求返回数据
        let dataset = res.data.data.DATASET;
        if(dataset.length==0){
          this.$message.error('获取配送方式失败，请联系管理员！');
          return false;
        }else{
          this.shipList=[];
          for(var j=0;j<dataset.length;j++){
            let ship = {};
            ship.value = dataset[j].VALUE;
            ship.name = dataset[j].VALUE;
            this.shipList.push(ship);
            // console.log(this.shipList);
          }
          // sessionStorage.setItem("USERINFO",dataset[0]);
          // this.$router.push('/home');
        }
      }).catch(err=>{
        // 请求失败执行
        // console.log(err)
      });
    },
    // 回复按钮
    replyContent(id,formName) {
      //可以调接口，添加回复

    },
    //显示问题详情列表
    contentDetail(id,content) {
      //可以通过调接口获取questionForm数据

    },
    //表格第二列文本颜色
    cellStyle({columnIndex}) {
      if(columnIndex==1) {
        return 'color:#409EFF;'
      }
    },
    handleChange(row){
      row.GoodsTaxAmount =  Math.round((row.GoodsNum*row.GoodsTaxPrice)*100)/100;
      this.changeTaxPrice(row);
      // this.lineCalculation();

    },
    lineCalculation(){
      let sumCount = 0 ;
      let sumTaxAmount = 0;
      for(var j=0;j<this.formData.tableData.length;j++){
        // console.log(this.formData.tableData[j].GoodsTaxAmount);

        sumTaxAmount = sumTaxAmount+this.formData.tableData[j].GoodsTaxAmount;
        sumCount ++;
      }
      this.totalAmount = sumTaxAmount;
      this.totalNum = sumCount;
    },

    getClients(){
      billOrders({
        M_STAFFID:this.userInfo.STAFFID,
        M_ORGID:this.userInfo.OWNERID,
        M_ENTID:this.userInfo.ENTID,
        M_CON:"%"+this.value ,
        M_COALL:"%"+this.value+"%",
        M_ACTION:0,
        M_PAGECOUNT:2000,
        M_PAGE:1
      }).then(res=>{
        // console.log(res);
        //这个接口数据是application/x-www-form-urlencoded，所以参数要进行qs转化
        // 请求返回数据
        let dataset = res.data.data.DATASET;
        if(dataset.length==0){
          this.$message.error('获取客户失败，请联系管理员！');
          return false;
        }else{
          // this.options=dataset;
          // console.log(dataset[0]);
          // sessionStorage.setItem("USERINFO",dataset[0]);
          // this.$router.push('/home');
        }
      }).catch(err=>{
        // 请求失败执行
        // console.log(err)
      })
    },
    closePopover(row){
      this.$refs[`popover-` + row.id].doClose();
    },
    changeTaxPrice(row){
      row.GoodsTaxAmount =  Math.round((row.GoodsNum*row.GoodsTaxPrice)*100)/100;
      let taxPrice = row.GoodsTaxPrice;
      let num = row.GoodsNum;
      let rate = row.Rate;
      let price = (taxPrice/(1+rate/100)).toFixed(6);
      let taxAmount = (taxPrice*num).toFixed(2)
      let amount = (price * num).toFixed(2) ;
      let tax = taxAmount - amount;
      row.TaxPrice = taxPrice;
      row.BaseTaxPrice = taxPrice;
      row.Price = price;
      row.BasePrice = price;
      row.TaxAmount = taxAmount;
      row.Amount = amount;
      row.tax = tax;
      row.Num = num;
      row.BaseNum = num;
      row.ExecNum = 0;
      this.lineCalculation();
    },
    columnAmount(row){
      row.GoodsTaxAmount =  Math.round((row.GoodsNum*row.GoodsTaxPrice)*100)/100;
      let taxPrice = row.GoodsTaxPrice;
      let num = row.GoodsNum;
      let rate = row.Rate;
      let price = (taxPrice/(1+rate/100)).toFixed(6);
      let taxAmount = (taxPrice*num).toFixed(2)
      let amount = (price * num).toFixed(2) ;
      let tax = taxAmount - amount;
      row.TaxPrice = taxPrice;
      row.BaseTaxPrice = taxPrice;
      row.Price = price;
      row.BasePrice = price;
      row.TaxAmount = taxAmount;
      row.Amount = amount;
      row.tax = tax;
      row.Num = num;
      row.BaseNum = num;
      row.ExecNum = 0;
      this.lineCalculation();
      // this.formData.tableData.push({});
      // console.log(this.formData.tableData[this.formData.tableData.length-1]);
      if(this.formData.tableData[this.formData.tableData.length-1].GoodsId!=undefined){
        this.addData();
      }
    },

    getBillNo(){
      getBillNo({
      }).then(res => {
        this.BillNo = res.data.data.BillNo;
      }).catch(err => {
        this.$message.error('获取单号失败，请重新打开页面！');
        return false;
      })
    },
    getBillAdj(){
      this.billHead = [];
      this.form=[];
      this.formData.tableData=[];
      this.getBillNo();
      billOrders({
        M_STAFFID:this.userInfo.STAFFID,
        M_ORGID:this.userInfo.OWNERID,
        M_ENTID:this.userInfo.ENTID,
        M_CON:"%"+this.value ,
        M_COALL:"%"+this.value+"%",
        M_ACTION:7,
        M_PAGECOUNT:2000,
        M_PAGE:1
      }).then(res=>{
        // console.log(res);
        //这个接口数据是application/x-www-form-urlencoded，所以参数要进行qs转化
        // 请求返回数据
        let dataset = res.data.data.DATASET;
        if(dataset.length==0){
          this.$message.error('获取单据失败，请联系管理员！');
          return false;
        }else{
          this.billHead = dataset;
          // this.options=dataset;
          // console.log(dataset[0]);
          // sessionStorage.setItem("USERINFO",dataset[0]);
          // this.$router.push('/home');
        }
      }).catch(err=>{
        // 请求失败执行
        // console.log(err)
      })
    },
    getBillDel(){
      this.form=[];
      this.formData.tableData=[];
      this.getBillNo();
      billOrders({
        M_STAFFID:this.userInfo.STAFFID,
        M_ORGID:this.userInfo.OWNERID,
        M_ENTID:this.userInfo.ENTID,
        M_BILLNO: this.BillNo,
        M_ACTION:41,
        M_PAGECOUNT:2000,
        M_PAGE:1
      }).then(res=>{
        // console.log(res);
        //这个接口数据是application/x-www-form-urlencoded，所以参数要进行qs转化
        // 请求返回数据
        let dataset = res.data.data.DATASET;
        if(dataset.length==0){
          this.$message.error('单据删除失败，请联系管理员！');
          return false;
        }else{
          this.form = [];
          this.formData.tableData=[];
          this.initForm();
        }
      }).catch(err=>{
        // 请求失败执行
        // console.log(err)
      })
    },
    async getBill(row) {

      let billno = row.BILLNO;
      await billOrders({
        M_STAFFID: this.userInfo.STAFFID,
        M_ORGID: this.userInfo.OWNERID,
        M_ENTID: this.userInfo.ENTID,
        M_CON: "%" + this.value,
        M_COALL: "%" + this.value + "%",
        M_ACTION: 81,
        M_PAGECOUNT: 2000,
        M_PAGE: 1,
        M_BILLNO: billno
      }).then(res => {
        // console.log(res);
        //这个接口数据是application/x-www-form-urlencoded，所以参数要进行qs转化
        // 请求返回数据
        let dataset = res.data.data.DATASET;
        if (dataset.length == 0) {
          this.$message.error('获取单据失败，请联系管理员！');
          return false;
        } else {
          console.log(dataset[0]);
          this.BillNo = dataset[0].BILLNO;
          this.BILLCODE = dataset[0].BILLCODE;
          this.form.businessId = dataset[0].BUSINESSID;
          this.form.businessName = dataset[0].BUSINESSNAME;
          this.form.address = dataset[0].ADDRESS;
          this.form.ship = dataset[0].DELIVERY;
          this.form.remark = dataset[0].REMARK;
          this.form.IsWMS = dataset[0].IS_WMS == 'Y' ? true : false;
          this.form.IsPlatform = dataset[0].IS_PT == 'Y' ? true : false;
          this.form.IsMerge = dataset[0].IS_HD == 'Y' ? true : false;
          this.form.orgName = dataset[0].OWNERNAME;
          if(this.form.businessId=="" || this.form.businessId==null){
            this.getBill(row);
          }
          // console.log(this.form);
          // sessionStorage.setItem("USERINFO",dataset[0]);
          // this.$router.push('/home');
        }
      }).catch(err => {
        // 请求失败执行
        // console.log(err)
      })
      await billOrders({
        M_STAFFID: this.userInfo.STAFFID,
        M_ORGID: this.userInfo.OWNERID,
        M_ENTID: this.userInfo.ENTID,
        M_CON: "%" + this.value,
        M_COALL: "%" + this.value + "%",
        M_ACTION: 82,
        M_PAGECOUNT: 2000,
        M_PAGE: 1,
        M_BILLNO: billno
      }).then(res => {
        // console.log(res);
        //这个接口数据是application/x-www-form-urlencoded，所以参数要进行qs转化
        // 请求返回数据
        let dataset = res.data.data.DATASET;
        if (dataset.length == 0) {
          this.$message.error('获取单据失败，请联系管理员！');
          return false;
        } else {
          for (var j = 0; j < dataset.length; j++) {
            let goods = {};
            goods.GoodsCode = dataset[j].GOODSCODE;
            goods.GoodsName = dataset[j].GOODSNAME;
            goods.GoodsSpec = dataset[j].GOODSSPEC;
            goods.GoodsMan = dataset[j].MANUFACTURER;
            goods.GoodsTaxPrice = dataset[j].SALETAXP;
            goods.GoodsNum = dataset[j].NUM;
            goods.GoodsTaxAmount = dataset[j].TAXAMOUNT;
            goods.BatchCode = dataset[j].BATCHCODE;
            goods.ProduceDate = dataset[j].PRODUCEDATE;
            goods.ValDate = dataset[j].VALDATE;
            goods.BillNo = dataset[j].BILLNO;
            goods.EntId = dataset[j].ENTID;
            goods.GoodsId = dataset[j].GOODSID;
            goods.OwnerId = dataset[j].OWNERID;
            goods.PackId = dataset[j].PACKID;
            goods.Meas = dataset[j].MEAS;
            goods.AngleId = dataset[j].ANGLEID;
            goods.Rate = dataset[j].RATE;
            goods.WhOrgId = dataset[j].WHORGID;
            goods.IsDone = dataset[j].ISDONE;
            goods.Unit = dataset[j].UNIT;
            goods.LocatId = dataset[j].LOCATID;
            goods.BillSN = dataset[j].BILLSN;
            goods.BillSort = dataset[j].BILLSORT;
            goods.DedRate = dataset[j].DEDRATE;
            goods.Profit = dataset[j].PROFIT;
            goods.Retailt = dataset[j].RETAILT;
            goods.IsFree = dataset[j].ISFREE;
            goods.BaseTaxPrice = dataset[j].BASETAXPRICE;
            goods.TaxPrice = dataset[j].TAXPRICE;
            goods.Price = dataset[j].PRICE;
            goods.BasePrice = dataset[j].BASEPRICE;
            goods.NUM = dataset[j].NUM;
            goods.BASENUM = dataset[j].BASENUM;
            goods.AMOUNT = dataset[j].AMOUNT;
            goods.TAXAMOUNT = dataset[j].TAXAMOUNT;
            goods.TAX = dataset[j].TAX;
            goods.isfree="N";
            goods.is_wlqr="N";
            goods.is_hwqr="N";
            goods.is_kfqr="N";
            goods.ischeck="N";
            goods.WhId = dataset[j].WHID;
            goods.WhOrgId = dataset[j].WHORGID;
            goods.kfqrshl=0;
            goods.kfqxshl=0;
            this.formData.tableData.push(goods);
            this.lineCalculation();
          }
        }
      }).catch(err => {
        // 请求失败执行
        // console.log(err)
      })
      this.initForm();
      this.$refs[`bill-1`].doClose();
    },
    initForm(){
      this.userInfo = JSON.parse(sessionStorage.getItem("USERINFO"));
      this.form.orgName = this.userInfo.OWNERNAME;
      this.form.staffName = this.userInfo.STAFFNAME;
    }
    // infinitScroll() {
    //   // 拿到表格挂载后的真实DOM
    //   const table = this.$refs.table;
    //   // 拿到表格中承载数据的div元素
    //   const divData = table.bodyWrapper
    //   divData.onmouseover = function () {
    //     clearInterval(t);
    //   }; //鼠标移入，停止滚动
    //   divData.onmouseout = function () {
    //     start()
    //   }; //鼠标移出，继续滚动
    //
    //   // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
    //   let t;
    //   function start() {
    //     // 数据少于表格高度停止滚动
    //     if (divData.clientHeight >= divData.scrollHeight){
    //       return;
    //     }
    //     t = setInterval(() => {
    //       // 元素自增距离顶部1像素
    //       divData.scrollTop += 1
    //       // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
    //       if (divData.clientHeight + divData.scrollTop == divData.scrollHeight) {
    //         // 重置table距离顶部距离
    //         divData.scrollTop = 0
    //       }
    //     }, 100)
    //   }
    //   start()
    //},
  },
  mounted() {
   this.initForm();
    if(this.formData.tableData.length==0){
      this.addData();
    }
    this.getShip();
    // this.infinitScroll();
    this.getBillNo();
  }
}
</script>

<style scoped>
.summary-class{
  width: 80%;
  margin-left: 10%;
}
.row-class{
  margin-top: 10px;
  display: flex;
  width: 100%;
}
.col-50-class{
  width: 50%;
  text-align: left;
  float: left;
  display: flex;
}
.col-25-class{
  width: 25%;
  text-align: left;
  float: left;
  display: flex;
}
.col-20-class{
  width: 20%;
  text-align: left;
  float: left;
  display: flex;
}
.liable-class{
  font-size: 15px;
  width: 80px;
  text-align: right;
  float: right;
  height: 40px;
  line-height: 40px;
}
.input-50-class{
  width: 80%;
  line-height: 40px;
  padding-left: 5px;
  padding-right: 5px;
}

.input-25-class{
  width: 60%;
  line-height: 40px;
  padding-left: 5px;
  padding-right: 5px;
}
.input-20-class{
  width: 60%;
  line-height: 40px;
  padding-left: 5px;
  padding-right: 5px;
}

.cont_title{
  margin: 10px auto;
  width: 80%;
  height: 35px;
  border-bottom: 2px solid #e6e6e6;
}
.cont_title>span{
  display: inline-block;
  font-weight: 700;
  font-size: 17px;
  height: 100%;
  width: 100px;
  text-align: center;
  line-height: 25px;
  cursor: pointer;
  color: #f40;
  border-bottom: 2px solid #f40;
  display: flex;
}

.tableClass{
  width: 80%;
  margin-left: 10%;
}
.table-button-class{
  float: right;
}

#footer{
  width: 80%;
  height: 50px;
  position: fixed;
  bottom: 0;
  left: 10%;
  background: #E5E5E5;
  z-index: 9999;
}
#footer div{
  display: inline-block;
}
#footer>.foot_select{
  width: 50px;
  height: 50px;
  line-height: 50px;
  padding-left: 5px;
  cursor: pointer;
  font-size: 14px;
}
.foot_select input,.foot_select label{
  cursor: pointer;
}
.foot_op{
  float: left;
  line-height: 50px;
  height: 50px;
}
.foot_op>.foot_remove{
  margin-left: 0px;
  font-size: 14px;
  cursor: pointer;
}
.foot_remove:hover{
  color: #f40;
}
.foot_total{
  float: right;
}
.foot_total>.amout-sum{
  cursor: pointer;
  height: 50px;
  color: #3c3c3c;
}
.foot_total .txt{
  line-height: 50px;
  font-size: 14px;
}
.amout-sum>#selected_amout{
  padding: 0 5px;
  color: #f40;
  font-weight: 700;
  font-size: 18px;
}
.price-sum{
  margin-left: 50px;
}
.price-sum>.selected_price{
  color: #f40;
  font-weight: 700;
  font-size: 20px;
  line-height: 50px;
}
.btn-area>.btn-sumbit{
  display: inline-block;
  background: #B0B0B0;
  color: #fff;
  border-left: 1px solid #e7e7e7;
  width: 119px;
  height: 50px;
  cursor: not-allowed;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
}
.btn-area>.btn-sumbit.btn-allow{
  background: #f22d00;
  cursor: pointer;
}
.left-btn{
  background: #387af6;
  cursor: pointer;
  display: inline-block;
  color: #fff;
  border-left: 1px solid #e7e7e7;
  width: 119px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
}
.tableClass{
  width: 80%;
  margin-left: 10%;
}
.client-check-class{
  margin-left: 10px;
  margin-top: 2%;
  height: 70px;
  width: 250px;
  font-size: 20px;
}
.clientRemarkClass>span{
  display: inline-block;
  font-size: 15px;
  height: 35px;
  font-weight: 700;
  position: absolute;
  top: 20%;
  margin-left: 7.5%;
  cursor: pointer;
}
.remark-class{
  display: flex;
}

.mt-class{
  /*float: left;*/
  width: 80%;
  margin-left: 10%;
}

</style>

<style>
.el-popover{
  height: 400px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/order/clientOrders2.vue